import SRCookies from "./cookies.js";
const axios = require("axios");
import objectToFormData from "../utils/objectToFormData";
import getUrlParameter from "../utils/getUrlParameter";
import { identity, pickBy, default as _ } from "lodash";
import $ from "jquery";
import clientData from "./clientData";


function deduceBaseUrlFromHostname() {
  return clientData('api_host').replace(/\/$/, '');
}

async function maybeGetJson(response) {
  const text = await response.text();

  try {
    return JSON.parse(text);
  } catch (e) {
    return null;
  }
}

export function buildQueryString(query) {
  return _.isEmpty(query) ? "" : "?" + $.param(query);
}

export class SRApi {
  constructor(config) {
    this.baseUrl = config?.baseUrl;
  }

  create(config) {
    return new SRApi(config);
  }

  setToken(token) {
    this.token = token;
  }

  base() {
    return (
      (this.baseUrl !== undefined && this.baseUrl) ||
      (window.__clientData && window.__clientData.API_URL) ||
      deduceBaseUrlFromHostname()
    );
  }

  headers() {
    return pickBy(
      {
        bearer: this.token ? null : this.bearer(),
        "Profile-Key": getUrlParameter("k"),
        Authorization: this.authorization(),
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
        "Content-Type": "application/json",
        "REVISION-HASH": clientData("revision_hash"),
      },
      identity
    );
  }

  bearer() {
    return SRCookies.session() ? SRCookies.session().session_id : null;
  }

  authorization() {
    return this.token ? `Bearer ${this.token}` : null;
  }

  clientData(name) {
    return clientData(name);
  }

  async get(path, query, { headers = {} } = {}) {
    return await this.request("GET", path, { query, headers });
  }

  async post(path, params, { headers = {} } = {}, returnResponse = false) {
    return await this.request('POST', path, { params, headers }, returnResponse)
  }

  /**
   *
   * @description Sends data to our API as multipart/form-data. This allows us to send fun things like files.
   * We needed to use axios (https://github.com/axios/axios) for this because the JavaScript fetch API wasn't cutting it.
   *
   * @param {String} path SR API route to send the request to.
   * @param {*} body Data to be sent.
   */
  async postFormData(path, body) {
    var headers = this.headers();
    headers["Content-Type"] = "multipart/form-data";

    var form = objectToFormData(body, "", ["profile_image"]);

    return axios.post(this.url(path), form, { headers });
  }

  async putJsonData(path, data) {
    var headers = this.headers();
    headers["Content-Type"] = "application/json";

    var json = JSON.stringify(data);
    return axios.put(this.url(path), json, { headers });
  }

  async put(path, params, { headers = {} } = {}) {
    return await this.request("PUT", path, { params, headers });
  }

  async delete(path, params, { headers = {} } = {}) {
    return await this.request("DELETE", path, { params, headers });
  }

  async request(method, path, { params, query, headers }) {
    const response = await fetch(this.url(path) + buildQueryString(query), {
      method,
      headers: { ...this.headers(), ...headers },
      body: JSON.stringify(params),
    });

    const data = await maybeGetJson(response);

    if (response.ok) {
      return data;
    } else {
      throw {
        status: response.status,
        response: data,
      };
    }
  }

  url(path) {
    return [this.base().replace(/\/$/, ""), path.replace(/^\//, "")].join("/");
  }
};


export default new SRApi();

